module.exports = __webpack_public_path__ + "static/img/1en.884a83c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/vivo/1en.png
// module id = qA2I
// module chunks = 0